
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.318 15.018a.685.685 0 00.398.126.685.685 0 00.65-.467l.213-.653a.918.918 0 01.581-.583l.666-.216a.693.693 0 00.462-.65.685.685 0 00-.483-.655l-.653-.212a.92.92 0 01-.583-.582l-.217-.664a.687.687 0 00-1.3.01l-.214.654a.919.919 0 01-.567.581l-.666.216a.693.693 0 00-.461.65.686.686 0 00.47.651l.654.213a.917.917 0 01.582.584l.217.665c.047.134.135.25.251.332zM4.972 12.332a.915.915 0 001.367-.38l.433-1.317A2.152 2.152 0 018.13 9.274l1.258-.41a.912.912 0 00-.035-1.736l-1.246-.404a2.148 2.148 0 01-1.36-1.359l-.41-1.259a.913.913 0 00-.334-.441.93.93 0 00-1.056 0 .916.916 0 00-.338.45L4.196 5.39A2.148 2.148 0 012.87 6.723l-1.26.409a.914.914 0 00.012 1.73l1.246.405c.404.135.76.387 1.022.723.15.194.264.41.34.642l.41 1.257c.063.18.18.334.334.443zM11.691 5.902a.533.533 0 00.815-.265l.165-.508a.715.715 0 01.452-.453l.518-.168a.539.539 0 00.255-.822.533.533 0 00-.271-.193l-.508-.165a.714.714 0 01-.454-.452l-.168-.517a.534.534 0 00-1.01.007l-.167.51a.715.715 0 01-.441.452l-.518.167a.54.54 0 00-.359.507.533.533 0 00.366.505l.508.166a.713.713 0 01.453.454l.169.517a.531.531 0 00.195.258z","fill":"#282E3E"}})])
          )
        }
      }
    